"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = __importDefault(require("react-jss"));
const button_style_1 = __importDefault(require("./button.style"));
const Button = ({ classes, className = '', children, onClick, type = 'button' }) => (jsx_runtime_1.jsx("button", Object.assign({ onClick: onClick, className: classnames_1.default(classes.button, className), 
    // eslint-disable-next-line react/button-has-type
    type: type }, { children: children }), void 0));
exports.Button = Button;
exports.default = react_jss_1.default(button_style_1.default)(exports.Button);
//# sourceMappingURL=index.js.map